'use client';

import React, { useState, useEffect } from 'react';

const PASSWORD = 'HailMary1709!*';
const SESSION_KEY = 'cortex_pw_auth';

export default function PasswordGate({ children }: { children: React.ReactNode }) {
  const [unlocked, setUnlocked] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (stored === 'true') {
      setUnlocked(true);
    }
    setInitialized(true);
  }, []);

  if (!initialized) {
    return <div className="min-h-screen" style={{ background: '#f8fafc' }} />;
  }

  if (unlocked) {
    return <>{children}</>;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input === PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      setUnlocked(true);
    } else {
      setError('Incorrect password. Please try again.');
      setInput('');
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: '#f8fafc' }}
    >
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-2">
            <img
              src="/assets/images/app_logo.png"
              alt="Cortex logo"
              className="h-8 w-auto"
              onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
            />
            <span className="text-2xl font-bold tracking-tight" style={{ color: '#1a1a2e' }}>
              Cortex
            </span>
          </div>
          <p className="text-sm" style={{ color: '#64748b' }}>AI-Powered OOH Sales Intelligence</p>
        </div>

        {/* Card */}
        <div
          className="rounded-2xl p-8 shadow-sm border"
          style={{ background: '#ffffff', borderColor: '#e2e8f0' }}
        >
          <h2 className="text-lg font-semibold mb-1" style={{ color: '#0f172a' }}>
            Welcome back
          </h2>
          <p className="text-sm mb-6" style={{ color: '#64748b' }}>
            Enter your password to access the platform.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="password"
                className="block text-xs font-medium mb-1.5"
                style={{ color: '#0f172a' }}
              >
                Password
              </label>
              <input
                id="password"
                type="password"
                autoFocus
                value={input}
                onChange={(e) => {
                  setInput(e.target.value);
                  if (error) setError('');
                }}
                placeholder="Enter password"
                className="w-full px-3.5 py-2.5 rounded-lg border text-sm focus:outline-none focus:ring-2 transition-colors"
                style={{
                  background: '#f8fafc',
                  borderColor: error ? '#f87171' : '#e2e8f0',
                  color: '#0f172a',
                  boxShadow: 'none',
                }}
              />
              {error && (
                <p className="mt-1.5 text-xs" style={{ color: '#ef4444' }}>
                  {error}
                </p>
              )}
            </div>

            <button
              type="submit"
              className="w-full py-2.5 px-4 text-white text-sm font-semibold rounded-lg transition-colors"
              style={{ background: '#5C00C4' }}
              onMouseEnter={(e) => { (e.target as HTMLButtonElement).style.background = '#4a009e'; }}
              onMouseLeave={(e) => { (e.target as HTMLButtonElement).style.background = '#5C00C4'; }}
            >
              Access Platform
            </button>
          </form>
        </div>

        <p className="mt-4 text-center text-xs" style={{ color: '#94a3b8' }}>
          v2.5
        </p>
      </div>
    </div>
  );
}
